import { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'

import styles from './Paragraph.module.scss'

const Paragraph = ({ className, ...props }: ComponentPropsWithoutRef<'p'>) => (
  <p className={clsx(styles.paragraph, className)} {...props} />
)

export default Paragraph
